module.exports = __webpack_public_path__ + "img/viwoods-ic.7819eb50.svg";